{{ value | amountRenderer }}
